export const User = 'user';
export const ADMIN = 'ADMIN';
export const CLIENT = 'CLIENT';

export const SENT = 'SENT';
export const ARCHIVED = 'ARCHIVED';

export const REQUIRED = 'REQUIRED';
export const COMPLETE = 'COMPLETE';
